import { Fragment, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import { useAuth } from "../utils/auth";
import { sdkWrapperURL } from "../utils/api-url-list";
import HealthScore from "../assets/images/Health-Score.svg";
import DiabetesScore from "../assets/icons/Diabetes.svg";
import CardiacScore from "../assets/icons/Cardiac.svg";
import NextArrow from "../assets/icons/icon_arrows2.svg";

const VitalsScore = () => {
  const {
    state: { scores },
  } = useLocation();
  const {
    userData: { profile_id },
    subscriptionPlanDetails: { packageName },
    getToken,
  } = useAuth();
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);

  const subscribe = async () => {
    try {
      const token = await getToken();
      const resp = await fetch(sdkWrapperURL("/users/add-saved-products"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          profile_id,
          product_id: "a5a5e1b5-fe4a-4224-b1bb-a37a9c4ca2d6",
          interest_filtration: "ACCEPT",
          application_info: {},
          module_type: "content",
        }),
      });
      const resp_json = await resp.json();
      if (resp_json.statusCode?.toString().startsWith("2"))
        setSuccessModalOpen(true);
      else throw new Error(resp_json.message);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="px-6 pb-24">
      <div className="flex items-center mb-5">
        <Link to={-1} className="mr-3">
          <svg
            width="6"
            height="10"
            viewBox="0 0 10 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.42402 16.2142C9.99277 15.6454 9.99277 14.7267 9.42402 14.1579L3.76569 8.49959L9.42402 2.84126C9.99277 2.27251 9.99277 1.35376 9.42402 0.785009C8.85527 0.216259 7.93652 0.216259 7.36777 0.785009L0.674024 7.47876C0.105274 8.04751 0.105274 8.96626 0.674024 9.53501L7.36777 16.2288C7.92194 16.7829 8.85527 16.7829 9.42402 16.2142Z"
              fill="#fff"
            />
          </svg>
        </Link>
        <h3 className="text-white text-[14px] font-semibold">Health Score</h3>
      </div>
      {packageName === "FREEMIUM" ||
      packageName === "LITE" ||
      packageName === "SBIG" ? (
        <div className="flex flex-col items-center mb-4 p-6 rounded-2xl bg-gradient-to-b from-[#063BC4] to-[#680FAD]/90 text-white text-center">
          <h4 className="font-semibold">Available Only for Members</h4>
          <p className="mt-5 text-sm font-light">
            Join our community to unlock this feature & other exclusive wellness
            offerings. Become a member today and take your health journey to the
            next level!
          </p>
          <button
            className="mt-6 px-6 py-3 rounded-full outline-none bg-white text-secondary text-sm font-medium"
            type="button"
            onClick={subscribe}
          >
            Request Membership
          </button>
          <Transition show={isSuccessModalOpen} as={Fragment}>
            <Dialog as={Fragment} onClose={() => setSuccessModalOpen(false)}>
              <Transition.Child
                className="fixed top-0 bottom-0 left-0 right-0 bg-black/70 flex items-center justify-center"
                enter="duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="duration-300 delay-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Transition.Child
                  as={Fragment}
                  enter="delay-150 duration-200"
                  enterFrom="opacity-0 scale-50"
                  enterTo="opacity-100 scale-100"
                  leave="duration-100"
                  leaveFrom="opacity-50 scale-50"
                  leaveTo="opacity-0 scale-0"
                >
                  <Dialog.Panel className="w-4/5 bg-white rounded-2xl p-6 flex flex-col items-center text-center">
                    <Dialog.Title className="text-secondary font-semibold">
                      Request Submitted Successfully!
                    </Dialog.Title>
                    <Dialog.Description className="mt-5 text-darkgray text-sm font-light">
                      Your membership request has been submitted successfully.
                      Our team will get back to you shortly. Welcome to the path
                      of better health and wellness!
                    </Dialog.Description>
                    <button
                      className="mt-6 px-6 py-3 rounded-full outline-none bg-gradient text-white text-sm font-medium"
                      type="button"
                      onClick={() => setSuccessModalOpen(false)}
                    >
                      Ok
                    </button>
                  </Dialog.Panel>
                </Transition.Child>
              </Transition.Child>
            </Dialog>
          </Transition>
        </div>
      ) : (
        <>
          {/* <Link
            to=""
            className="w-[48%] bg-[#c9e8ff] rounded-[30px] px-4 py-4 flex flex-col items-center justify-center mb-4 min-h-[190px]"
          >
            <img src={MyCare} width="45" alt="" />
            <h5 className="text-sm font-semibold text-white mt-3">
              My Digital Health Assessment Score
            </h5>
          </Link> */}
          <Link
            to="/score-details"
            state={{ scoreData: scores?.vitalsScore }}
            className={`w-[100%] bg-gradient-to-b from-[#5517A7] to-[#02102B] rounded-[30px] px-4 py-4 flex items-center justify-start mb-4 h-[67px] ${
              scores?.vitalsScore?.score !== null ? "" : "grayscale"
            }`}
            onClick={(e) => {
              if (scores?.vitalsScore?.score === null) {
                e.preventDefault();
                setModalOpen(true);
              }
            }}
          >
            <img src={HealthScore} width="45" alt="" />
            <div className=" flex items-center justify-between w-[80%] ml-4">
              <h5 className="text-sm font-semibold text-white">Vitals Index</h5>
              <img src={NextArrow} alt="" width="20" className="mr-3" />
              {/* <p className="text-[11px]">
                The vitals score is a comprehensive health assessment.
              </p> */}
            </div>
          </Link>
          <Link
            to="/score-details"
            state={{ scoreData: scores.diabetesScore }}
            className={`w-[100%] bg-gradient-to-b from-[#2055F3] to-[#02102B] rounded-[30px] px-4 py-4 flex items-center justify-start mb-4 h-[67px] ${
              scores?.diabetesScore?.score !== null ? "" : "grayscale"
            }`}
            onClick={(e) => {
              if (scores?.diabetesScore?.score === null) {
                e.preventDefault();
                setModalOpen(true);
              }
            }}
          >
            <img src={DiabetesScore} width="45" alt="" />
            <div className=" flex items-center ml-4 w-[80%] justify-between">
              <h5 className="text-sm font-semibold text-white">
                Diabetes Insight
              </h5>
              <img src={NextArrow} alt="" width="20" className="mr-3" />
            </div>
          </Link>
          <Link
            to="/score-details"
            state={{ scoreData: scores.heartScore }}
            className={`w-[100%] bg-gradient-to-b from-[#543C9A] to-[#02102B] rounded-[30px] px-4 py-4 flex items-center justify-start mb-4 h-[67px] ${
              scores?.heartScore?.score !== null ? "" : "grayscale"
            } `}
            onClick={(e) => {
              if (scores?.heartScore?.score === null) {
                e.preventDefault();
                setModalOpen(true);
              }
            }}
          >
            <img src={CardiacScore} width="45" alt="" />
            <div className=" flex items-center justify-between ml-4 w-[80%]">
              <h5 className="text-sm font-semibold text-white">Heart Score</h5>
              <img src={NextArrow} alt="" width="20" className="mr-3" />
            </div>
          </Link>
        </>
      )}
      <Link
        to="/score-details"
        state={{ scoreData: scores.dhaScore }}
        className={`w-[100%] bg-gradient-to-b from-[#5033FF] to-[#02102B] rounded-[30px] px-4 py-4 flex items-center justify-start mb-4 h-[67px] ${
          scores?.dhaScore?.score !== null ? "" : "grayscale"
        }`}
        onClick={(e) => {
          if (scores?.dhaScore?.score === null) {
            e.preventDefault();
            setModalOpen(true);
          }
        }}
      >
        <svg
          width="45"
          height="34"
          viewBox="0 0 48 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.4623 35.8969C24.4248 35.8499 24.0774 35.5965 23.6832 35.343C23.2795 35.0896 22.9228 34.8455 22.8665 34.7986C22.782 34.7329 22.078 34.2447 21.4678 33.8411C21.1205 33.6158 20.0034 32.7803 19.6279 32.4799C19.4308 32.3297 19.1491 32.1044 19.0083 31.9918C17.4782 30.809 16.3517 29.8046 14.7935 28.2557C13.3384 26.8007 12.8973 26.3219 12.1181 25.3362C11.7989 24.9326 11.4986 24.5853 11.4516 24.5665C11.4047 24.5477 11.3671 24.482 11.3671 24.4069C11.3671 24.3412 11.3014 24.2379 11.2169 24.1628C11.1418 24.0971 10.8602 23.7123 10.5974 23.3086L10.1186 22.5764H5.59399C0.571826 22.5764 0.618762 22.5764 0.205724 21.9756C-0.244862 21.2904 0.0930777 20.361 0.881604 20.1451C1.16322 20.07 3.13454 20.0419 7.88447 20.0606C14.3053 20.0888 14.4931 20.0982 14.5963 20.2671C14.6527 20.3704 14.9155 20.7647 15.169 21.1495C15.4318 21.5344 15.6759 21.9193 15.7322 22.0038C15.7791 22.0883 16.0138 22.445 16.2485 22.7923C16.4832 23.149 16.7272 23.5433 16.7929 23.6653C16.9901 24.0314 17.6378 24.4539 18.0039 24.4539C18.7173 24.4539 19.2336 23.9469 19.4777 22.9894C19.5622 22.6327 19.7499 21.9193 19.8813 21.403C20.0034 20.8867 20.2287 20.0794 20.3601 19.6007L20.6042 18.737L20.9139 20.07C21.0829 20.8022 21.3458 21.9569 21.4959 22.6233C21.6461 23.2992 21.8808 24.3318 22.0122 24.9232C22.1531 25.5146 22.2563 26.0778 22.2563 26.1623C22.2563 26.4346 22.8102 26.979 23.2044 27.0917C23.9554 27.317 24.7627 26.7913 24.9692 25.937C25.0255 25.7117 25.1945 25.1297 25.3353 24.6416C25.4855 24.1535 25.7296 23.3462 25.8704 22.858C26.0112 22.3699 26.2459 21.5907 26.3867 21.1214C26.5275 20.6614 26.781 19.8166 26.9405 19.2439C27.1001 18.6807 27.3536 17.8077 27.5038 17.3196C27.654 16.8314 27.9074 15.9678 28.0764 15.3952C28.2454 14.8319 28.4988 14.0059 28.6302 13.5834L28.8837 12.7949L29.1465 13.6773C29.2967 14.1561 29.5314 14.9352 29.6722 15.3952C30.0008 16.4372 30.4607 17.9485 30.6673 18.6338C30.8926 19.3848 31.0521 19.6476 31.3901 19.8541C31.6811 20.0325 31.9158 20.0419 39.1909 20.0419C44.5604 20.0419 46.7945 20.07 47.048 20.1451C47.5079 20.2859 47.9022 20.8304 47.9022 21.3091C47.9022 21.5063 47.8083 21.7785 47.6863 21.9756C47.2826 22.5764 47.2826 22.5764 42.6266 22.5764H38.4211L38.1301 23.027C37.9705 23.2711 37.7452 23.5996 37.6326 23.7592C37.5105 23.9188 37.3322 24.1722 37.2289 24.3224C36.4404 25.4864 34.4879 27.7112 32.7231 29.476C30.6673 31.5412 28.2829 33.5782 26.0487 35.2022C25.8986 35.3055 25.6075 35.5308 25.3823 35.6997C24.9786 36.0001 24.575 36.0846 24.4623 35.8969Z"
            fill="#A977F9"
          />
          <path
            d="M23.5899 19.4315C23.4773 18.9152 23.2614 17.9484 23.1112 17.2725C22.961 16.606 22.7169 15.5265 22.5855 14.8787C22.4447 14.231 22.2663 13.4143 22.1912 13.0482C22.1067 12.6915 21.9659 12.2503 21.8627 12.0814C21.6655 11.7528 21.0835 11.4055 20.7456 11.4055C20.4264 11.4055 19.7693 11.7528 19.6473 11.9969C19.4783 12.316 19.0653 13.5739 19.0653 13.7711C19.0653 13.8649 18.9432 14.3812 18.7837 14.9069C18.6335 15.4326 18.38 16.3713 18.2204 16.9909C17.7511 18.7463 17.5445 19.516 17.4976 19.6005C17.4695 19.6381 17.1503 19.2156 16.7842 18.6618C16.3993 18.0892 15.9675 17.5541 15.7891 17.4415L15.47 17.2255H11.349H7.23738L6.99331 16.6905C6.67414 15.9864 6.01704 14.1747 5.92317 13.7523C5.88562 13.5739 5.74481 13.0013 5.61339 12.485C5.17219 10.7296 5.07832 9.08683 5.30361 7.35958C5.56645 5.38826 6.29866 3.6704 7.39696 2.48761C8.72995 1.04198 10.2319 0.413038 12.6538 0.262842C14.3623 0.159583 17.0846 0.628944 19.1216 1.37053C19.544 1.52073 19.9289 1.64276 19.9852 1.64276C20.0509 1.64276 20.3983 1.77418 20.7738 1.93377C21.4778 2.22477 21.7782 2.36558 23.2238 3.04146C23.6838 3.24798 24.0968 3.42634 24.1438 3.42634C24.2189 3.42634 27.1852 2.01825 27.7203 1.72725C27.8142 1.68031 27.9644 1.64276 28.0582 1.64276C28.1521 1.64276 28.2648 1.60521 28.3117 1.56767C28.5745 1.33299 30.9213 0.600782 32.4421 0.262842C33.5404 0.0281617 33.8408 0 35.3521 0C36.9855 0.00938722 37.07 0.0187744 37.9618 0.309778C40.9469 1.27666 42.5803 3.47327 43.1998 7.32203C43.397 8.57053 43.397 8.80521 43.1811 10.7484C43.0027 12.3536 42.3268 14.8787 41.482 17.1317L41.2567 17.7418L37.2202 17.77L33.1837 17.7888L32.9208 16.9252C32.6768 16.1085 32.5453 15.6673 31.8788 13.3768C31.738 12.8887 31.5034 12.1095 31.3625 11.6402C31.0715 10.692 30.6116 9.1056 30.3769 8.26075C30.0202 7.02164 29.579 6.52412 28.8186 6.52412C28.415 6.52412 28.3211 6.56167 28.0113 6.88083C27.7391 7.14367 27.5983 7.40652 27.4293 7.97914C27.1289 8.98357 26.7159 10.401 26.3685 11.5463C26.2183 12.0626 25.9743 12.8887 25.8335 13.3768C25.6833 13.8649 25.4486 14.6722 25.3078 15.1604C25.167 15.6485 24.9323 16.4558 24.7821 16.9439C24.3221 18.4834 23.9748 19.7038 23.8809 20.0417C23.8058 20.3515 23.7871 20.3233 23.5899 19.4315Z"
            fill="#A977F9"
          />
        </svg>
        <div className=" flex items-center justify-between ml-4 w-[80%]">
          <h5 className="text-sm font-semibold text-white">
            Digital Health Assessment Score
          </h5>
          <img src={NextArrow} alt="" width="20" className="mr-3" />
        </div>
      </Link>
      <Transition show={isModalOpen} as={Fragment}>
        <Dialog as={Fragment} onClose={() => {}}>
          <Transition.Child
            className="fixed top-0 bottom-0 left-0 right-0 bg-black/70 flex items-center justify-center"
            enter="duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="duration-300 delay-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Transition.Child
              as={Fragment}
              enter="delay-150 duration-200"
              enterFrom="opacity-0 scale-50"
              enterTo="opacity-100 scale-100"
              leave="duration-100"
              leaveFrom="opacity-50 scale-50"
              leaveTo="opacity-0 scale-0"
            >
              <Dialog.Panel className="w-4/5 bg-white rounded-2xl p-6 flex flex-col text-center">
                <Dialog.Description className="text-black font-normal text-sm">
                  This score is not generated yet.
                  <br />
                  Please do a scan to generate scores.
                </Dialog.Description>
                <div className="mt-6 w-full flex justify-evenly">
                  <button
                    className="w-24 px-4 py-2 rounded-full bg-white text-[#FA6363] border border-[#FA6363] text-xs font-medium"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Close
                  </button>
                  <Link
                    className="w-24 px-4 py-2 rounded-full bg-gradient text-white text-xs font-medium"
                    to="/start-scan"
                  >
                    Scan Now
                  </Link>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </Transition.Child>
        </Dialog>
      </Transition>
    </div>
  );
};

export default VitalsScore;
